<template>
  <div class="trees">
    <!-- 组织结构目录树结构 -->
    <template v-if="type === 'GROUP'">
      <div class="trees-title">{{ $t(title) }}</div>
      <div class="trees-search">
        <el-select v-model="keyword" size="mini" style="width: 100%" filterable :filter-method="search"
          @change="searchChange" @focus="focus" @blur="blur" :placeholder="$t('cbt1')">
          <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div class="trees-content" id="GROUP" style="height: calc(100% - 78px)">
        <el-tree ref="GROUP" node-key="id" :current-node-key="parseInt(currentNodeKey)" default-expand-all :data="list"
          :props="structure" @node-click="handleNodeClick" v-loading="loading" :expand-on-click-node="false"
          :highlight-current="true" :show-checkbox="showCheckbox" @check-change="handleCheckChange"></el-tree>
      </div>
    </template>
    <!-- 素材库树结构 -->
    <template v-if="type === 'CATALOG'">
      <div class="trees-title" v-if="showTitle">{{ $t(title) }}</div>
      <div class="trees-content">
        <div v-if="isGetAll" class="isImg" :class="{ select: currentNodeKey === '0' }"
          @click="handleNodeClick({ id: '0' })">
          {{ $t('cbt2') }}
        </div>
        <el-tree ref="CATALOG" node-key="id" :current-node-key="parseInt(currentNodeKey)" default-expand-all
          :data="list" :props="structure" @node-click="handleNodeClick" v-loading="loading"
          :expand-on-click-node="false" :highlight-current="true"></el-tree>
      </div>
    </template>
    <!-- 插播类型树结构 -->
    <template v-if="type === 'INTER_CUT'">
      <div class="trees-title">
        {{ title }}
        <img src="@/assets/images/public/public_addsome.png" class="icon" @click="handleNodeClick({ event: 'add' })"
          v-if="type === 'INTER_CUT'" alt />
      </div>
      <div class="trees-content">
        <div v-if="isGetAll" class="isImg" :class="{ select: currentNodeKey === '0' }"
          @click="handleNodeClick({ id: '0' })">
          {{ $t('cbt3') }}
        </div>
        <el-tree ref="INTER_CUT" node-key="id" :current-node-key="parseInt(currentNodeKey)" default-expand-all
          :data="list" :props="structure" @node-click="handleNodeClick" v-loading="loading"
          :expand-on-click-node="false" :highlight-current="true">
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <span class="item-name">{{ node.label }}</span>
            <span v-if="data.id === editId" @click.stop>
              <span class="edit-item" @click="handleNodeClick({ event: 'del', id: data.id })">{{ $t('cbt4') }}</span>
              <span class="edit-item" @click="handleNodeClick({ event: 'edit', id: data.id })">{{ $t('cbt5') }}</span>
            </span>
            <img v-else class="icon" src="@/assets/images/public/public_more.png" @click.stop="handleEdit(node, data)"
              alt />
          </span>
        </el-tree>
      </div>
    </template>
    <!-- 素材目录 -->
    <template v-if="type === 'FILELIST'">
      <div class="trees-title" v-if="showTitle">{{ $t(title) }}</div>
      <div class="trees-search">
        <el-select v-model="keyword" size="mini" style="width: 100%" filterable :filter-method="search"
          @change="searchChange" @focus="focus" @blur="blur" :placeholder="$t('cbt1')">
          <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div class="trees-content" id="FILELIST" style="height: calc(100% - 78px)">
        <el-tree ref="FILELIST" node-key="id" :current-node-key="parseInt(currentNodeKey)" default-expand-all
          :data="list" :props="structure" @node-click="handleNodeClick" v-loading="loading"
          :expand-on-click-node="false" :highlight-current="true">
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <span>{{ data.group_dir == 1 ? "※" : "" }}{{ node.label }}</span>
          </span>
        </el-tree>
      </div>
    </template>
  </div>
</template>
<script>
/**
 * #type:参数
 * 传入书需要显示的结构类型:CATALOG:多媒体类型的列表 GROUP:组织结构类型的列表
 * #list:参数
 * 树结构需要显示的数据，直接将请求回来的数据传入
 */

import Utils from "@/assets/scripts/Utils";
import { getChildrenIds, getBreadcrumb } from "@/assets/scripts/publicFunction";
import superClone from '@/assets/scripts/superClone.js'
// 显示数据读取格式
let STRUCTURE = {
  GROUP: { children: 'child', label: 'name' },
  CATALOG: { children: 'child', label: 'remark' },
  INTER_CUT: { children: 'child', label: 'name' },
  FILELIST: { children: 'child', label: 'name' },
}
// 树结构标题
let TITLE = {
  GROUP: 'basics.structureGrouping',
  CATALOG: "素材库",
  INTER_CUT: 'basics.inStreamType',
  FILELIST: 'basics.materialCatalogue'
}
// GROUP: Vue.$i18n.t('basics.structureGrouping'),
// CATALOG: "素材库",
// INTER_CUT: Vue.$i18n.t('basics.inStreamType'),
// FILELIST: Vue.$i18n.t('basics.materialCatalogue'),
export default {
  name: "tree",
  props: {
    // 树结构显示的数据类型
    type: {
      type: String,
      required: true
    },
    // 树结构需要显示的数据
    list: {
      type: Array,
      required: true
    },
    // 当前选中节点
    select: {
      type: String,
      default: '1'
    },
    // 是否显示获取全部
    isGetAll: {
      type: Boolean,
      default: true
    },
    showTitle: {
      type: Boolean,
      default: true
    },
    showCheckbox: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      structure: STRUCTURE[this.type],
      title: TITLE[this.type],
      editId: '0',
      currentNodeKey: this.select,
      keyword: "",
      options: [],
      flatteningList: [],
      checkedList: []
    };
  },
  created() {
    this.type === 'GROUP' && (this.currentNodeKey = '1');
    this.flatteningList = this.flattening(this.list);
  },
  methods: {
    focus() {
      // this.keyword = "";
    },
    blur() {
      // this.options = [];
    },
    handleCheckChange(data, checked) {
      if (checked) {
        this.checkedList.push(data);
      } else {
        let index = this.checkedList.findIndex(v => v.id === data.id);
        index > -1 && this.checkedList.splice(index, 1);
      }
      // console.log(this.checkedList);
      let ids = { type: '', check: [] };
      ids.type = 'CHECK_GROUP';
      ids.check = this.checkedList.map(v => v.id);
      this.$emit('getAssets', ids);
    },
    searchChange(nVal) {
      this.currentNodeKey = nVal;
      this.$refs[this.type].setCurrentKey(nVal);
      this.handleNodeClick({ id: nVal });
      let el = document.getElementById(this.type);
      el.scrollTop = (this.flatteningList.findIndex(v => v.id === nVal) * 32) - 32;
      setTimeout(() => {
        this.keyword = "";
      }, 5000);
    },
    search(keyword) {
      let filterList = superClone(this.flatteningList).filter((v) => {
        return v.name.indexOf(keyword) !== -1;
      });
      filterList.forEach((v) => {
        v.label = getBreadcrumb(this.list, v.id).reverse().map(g => g.name);
      });
      this.options = this.distinct(filterList);
    },
    distinct(list) {
      let i = 1;
      while ([... new Set(list.map(v => v.name))].length < list.length) {
        list = list.map((v) => {
          if (i < v.label.length) {
            v.name = v.label.slice(-1 * i).join("/");
          }
          return v;
        })
        i++;
        if (i > 100) { break; }
      }
      return list;
    },
    flattening(arr, list = []) {
      arr.forEach((v) => {
        const { pid, id, name } = v;
        list.push({ pid, id, name });
        v.child.length > 0 && this.flattening(v.child, list);
        // const { pid, id, name } = v;
        // list.push({ pid, id, name });
      });

      return list;
    },

    handleNodeClick(data) {
      // console.log(data);

      // 设置当前选中的子树
      this.currentNodeKey = data.id;

      let ids = { type: '', id: '0' };
      // 组织结构
      if (this.type === 'GROUP') {
        ids.id = data.id;
        ids.type = 'GROUP';
        ids.ids = getChildrenIds(this.groupIdList, ids.id).join(",");
      }
      // 媒体
      if (this.type === 'CATALOG') {
        // 当选中树的第零个时需要清除其他所有选项
        data.id === '0' && this.$refs.CATALOG.setCurrentKey(null);

        ids.id = data.id;
        ids.type = 'CATALOG';
        ids.fileType = data.type;
      }
      // 插播类型
      if (this.type === 'INTER_CUT') {
        // 当选中树的第零个时需要清除其他所有选项
        data.id === '0' && this.$refs.INTER_CUT.setCurrentKey(null);

        ids.id = data.id;
        ids.type = 'INTER_CUT';
        ids.event = data.event;
      }
      // 文件列表
      if (this.type === "FILELIST") {
        ids.id = data.id;
        ids.type = 'FILELIST';
        ids.groupId = data.group_id;
      }
      // console.log(ids);
      this.$emit('getAssets', ids);
      // 隐藏操作选项
      this.editId = -1;
    },
    handleEdit(node, data) {
      // console.log(node, data);
      this.editId = data.id;
    }
  },
  computed: {
    loading() {
      return !(this.list.length > 0);
    },
    groupIdList() {
      let self = this;
      let data = Utils.MSDataTransfer.treeToArray(
        self.list,
        null,
        null,
        self.defaultExpandAll
      );
      return data;
    },
  },
  watch: {
    select: {
      handler(nVal) {
        if (this.type === 'FILELIST') {
          this.currentNodeKey = nVal;
          this.$refs.FILELIST.setCurrentKey(nVal);
        }
      }
    },
    list: {
      // immediate: true,
      handler(v) {
        this.flatteningList = this.flattening(v);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.trees {
  width: 100%;
  height: 50%;
  flex: 1;
  background-color: #fff;
  border-radius: 0px 8px 8px 0px;

  .trees-title {
    width: 100%;
    height: 44px;
    font-size: 16px;
    line-height: 44px;
    text-align: center;
    color: #fff;
    // background-image: linear-gradient(270deg,
    //     #86eae7 0%,
    //     #4cccf0 45%,
    //     #11adf8 100%),
    //   linear-gradient(#9fb5da, #9fb5da);
    background-color: var(--theme-color-customized-1);
    background-blend-mode: normal, normal;
    border-radius: 0px 8px 0px 0px;
    position: relative;

    .icon {
      width: 30px;
      height: 30px;
      position: absolute;
      top: 50%;
      left: 100%;
      transform: translate(-120%, -50%);
    }
  }

  .trees-search {
    padding: 2px;

    // /deep/ .el-input__inner {
    //   height: 30px;
    //   line-height: 30px;
    //   border-radius: 15px;
    // }

    // /deep/ .el-input__suffix {
    //   line-height: 30px;
    //   color: var(--theme-color-customized-1);
    //   font-size: 16px;
    //   right: 10px;
    // }

    // .icon {
    //   margin-right: 0px;
    //   margin-left: 25px;
    // }
  }

  .isImg {
    height: 30px;
    line-height: 30px;
    text-align: center;
    font-size: 16px;
    // color: #fff;
    background-color: #edfbff;
    border-right: 1px solid #fff;
    cursor: pointer;
  }

  .select {
    border-left: 4px solid #4cccf0;
    background-color: #e5f9fd;
  }

  .trees-content {
    padding-right: 2px;
    height: calc(100% - 44px);
    overflow: auto;

    .custom-tree-node {
      max-width: 148px;
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-right: 8px;

      .icon {
        width: 20px;
        height: 20px;
      }

      .item-name {
        margin-right: 6px;
        max-width: 116px;
        overflow: hidden;
      }

      .edit-item {
        font-size: 14px;
        color: #ff4949;
      }

      .edit-item+.edit-item {
        margin-left: 6px;
        color: #606266;
      }
    }
  }

  /deep/ .el-tree-node__label {
    font-size: 16px;
  }

  /deep/ .el-tree-node__expand-icon {
    font-size: 16px;
  }

  /deep/ .el-tree-node.is-current>.el-tree-node__content {
    border-left: 4px solid #4cccf0;
    background-color: #e5f9fd;
  }

  /deep/ .el-tree-node__content {
    height: 32px;
  }
}

.trees+.trees {
  margin-top: 12px;
}
</style>
